import type { Icon } from '../../../src/lib/types'
export const mdiPageNextOutline: Icon = {
  "id": "page-next-outline",
  "name": "Page Next Outline",
  "path": "M22,3H5A2,2 0 0,0 3,5V9H5V5H22V19H5V15H3V19A2,2 0 0,0 5,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M7,15V13H0V11H7V9L11,12L7,15M20,13H13V11H20V13M20,9H13V7H20V9M17,17H13V15H17V17Z",
  "as": [
    "read-more-outline"
  ],
  "tags": []
}
export default mdiPageNextOutline